export const formatFileSize = (bytes: number): string => {
  if (!Number.isFinite(bytes) || bytes <= 0) return '0 B';

  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  const exp = Math.min(
    Math.floor(Math.log(bytes) / Math.log(1024)),
    units.length - 1,
  );
  const value = bytes / 1024 ** exp;

  let fractionDigits = 2;
  if (value >= 100 || exp === 0) {
    fractionDigits = 0;
  } else if (value >= 10) {
    fractionDigits = 1;
  }
  return `${new Intl.NumberFormat('ru-RU', { maximumFractionDigits: fractionDigits }).format(value)} ${units[exp]}`;
};
